<template>
	<div>
		<div class="mt-4 pt-4">
			<h1>Category</h1>
			<div class="mt-4">
				<div class="row">
					<div class="col-12">
						<div class="card">
							<div class="card-header text-end">
								<button
									class="btn btn-outline-info"
									data-bs-toggle="modal"
									data-bs-target="#forms"
									id="triggerModals"
									v-on:click="catId = 0;refresh = Math.random()"
								>Create new category</button>
							</div>
							<div class="card-body">
								<div class="table-responsive">
									<table class="table table-striped">
										<thead>
											<tr>
												<th>Title</th>
												<th class="text-center">Catalogue</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="c in category" :key="c.ID">
												<td>{{ c.title }}</td>
												<td class="text-center">{{ c.weakness_count }}</td>
												<td class="text-end">
													<a href="javascript:void(0)"
													class="text-warning"
													data-bs-toggle="modal"
													data-bs-target="#forms"
													v-on:click="update(c.ID)">
														<i class="far fa-edit"></i>
													</a> |
													<a
														href="javascript:void(0)"
														class="text-danger"
														title="Delete"
														v-on:click="deleteCategory(c.ID)"
														v-if="c.weakness_count == 0"
														>
														<i class="fa fa-trash"></i>
													</a>
													<i
														title="Category contain catalogue"
														class="fa fa-trash" v-else></i>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="modal" id="forms" tabindex="-1">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						{{ catCallBack }} Category
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="closeModal"></button>
					</div>
					<div class="modal-body">
						<Form v-on:callback="formCallback" :catId="catId" :key="refresh" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
  import Form from '@/views/Admin/CategoryForm.vue'

    export default {
		components: {
			Form
		},
        data() {
            return {
                category: [],
                catCallBack: '',
                catId: 0,
                refresh: Math.random()
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
				const me = this;
                this.$axios.get(this.$server + 'category')
                .then(res => {
                    var r = res.data;
                    if (r.success) {
                        me.category = r.data;
                    }
                });
            },

            formCallback(callback) {
				this.catCallBack = callback;
				if (callback == true) { // "need == true" as not empty value will return true
					this.refresh = Math.random();
					this.init();
					document.getElementById("closeModal").click(); // manual close for a moment
				}
            },

			update(id) {
				this.catId = id;
				this.refresh = Math.random();
			},

            deleteCategory(id){
                var c = confirm("Do you really want to delete this record?");
                if (c) {
                    const me = this;
                    this.$axios.delete(`${this.$server}category/${id}`)
                    .then(res => {
                        var r = res.data;
                        if (r.success) {
                            // reload data
                            this.init();
							this.$swal({
								title: r.message
							});
                        }
                    });
                }
            }
        }
    }
</script>